import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerBodyInlineStyles = /*#__PURE__*/function () {
  function BlockerBodyInlineStyles() {
    _classCallCheck(this, BlockerBodyInlineStyles);
  }

  _createClass(BlockerBodyInlineStyles, null, [{
    key: "bodyContainer",
    value: function bodyContainer(_ref) {
      var type = _ref.layout.type,
          _ref$design = _ref.design,
          bg = _ref$design.bg,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          padding = _ref.bodyDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        background: bg,
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        lineHeight: 1.4
      };

      if (type === "dialog" && borderWidth > 0) {
        style.borderLeft = "".concat(borderWidth, "px solid ").concat(borderColor);
        style.borderRight = style.borderLeft;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body-container",
        style: style
      };
    }
  }, {
    key: "body",
    value: function body(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var style = {
        margin: "auto"
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-body",
        style: style
      };
    }
  }, {
    key: "description",
    value: function description(_ref3) {
      var fontSize = _ref3.design.fontSize,
          _ref3$bodyDesign = _ref3.bodyDesign,
          descriptionInheritFontSize = _ref3$bodyDesign.descriptionInheritFontSize,
          descriptionFontSize = _ref3$bodyDesign.descriptionFontSize,
          descriptionTextAlign = _ref3.individualLayout.descriptionTextAlign,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-description",
        style: {
          marginBottom: 10,
          fontSize: descriptionInheritFontSize ? +fontSize : +descriptionFontSize,
          textAlign: descriptionTextAlign
        }
      };
    }
  }, {
    key: "teachingsSeparator",
    value: function teachingsSeparator(_ref4) {
      var borderRadius = _ref4.layout.borderRadius,
          _ref4$bodyDesign = _ref4.bodyDesign,
          teachingsSeparatorActive = _ref4$bodyDesign.teachingsSeparatorActive,
          teachingsSeparatorWidth = _ref4$bodyDesign.teachingsSeparatorWidth,
          teachingsSeparatorHeight = _ref4$bodyDesign.teachingsSeparatorHeight,
          teachingsSeparatorColor = _ref4$bodyDesign.teachingsSeparatorColor,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-teachings-separator",
        style: {
          marginTop: 7,
          display: "inline-block",
          maxWidth: "100%",
          borderRadius: +borderRadius,
          width: +teachingsSeparatorWidth,
          height: teachingsSeparatorActive ? +teachingsSeparatorHeight : 0,
          background: teachingsSeparatorColor
        }
      };
    }
  }, {
    key: "teaching",
    value: function teaching(_ref5) {
      var _ref5$bodyDesign = _ref5.bodyDesign,
          teachingsInheritTextAlign = _ref5$bodyDesign.teachingsInheritTextAlign,
          teachingsTextAlign = _ref5$bodyDesign.teachingsTextAlign,
          teachingsInheritFontSize = _ref5$bodyDesign.teachingsInheritFontSize,
          teachingsFontSize = _ref5$bodyDesign.teachingsFontSize,
          teachingsInheritFontColor = _ref5$bodyDesign.teachingsInheritFontColor,
          teachingsFontColor = _ref5$bodyDesign.teachingsFontColor,
          antiAdBlocker = _ref5.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-teachings",
        style: {
          marginTop: 7,
          display: "inline-block",
          textAlign: teachingsInheritTextAlign ? undefined : teachingsTextAlign,
          fontSize: teachingsInheritFontSize ? undefined : +teachingsFontSize,
          color: teachingsInheritFontColor ? undefined : teachingsFontColor
        }
      };
    }
  }]);

  return BlockerBodyInlineStyles;
}();

export { BlockerBodyInlineStyles };